function compareOrder(a, b) {
  return (a?.order ?? 0) - (b?.order ?? 0)
}

function sortByOrder(array) {
  return array.slice().sort(compareOrder)
}

class SortUtility {
  ascending = {
    /**
     * Comparator for ascending numeric `order`. Missing `order` counts as `0`.
     *
     * @param {{ order?: number|null }|null|undefined} a
     * @param {{ order?: number|null }|null|undefined} b
     * @returns {number}
     */
    order(a, b) {
      return compareOrder(a, b)
    },

    /**
     * Return a shallow copy of `array` sorted ascending by `order`. Does
     * not mutate `array`.
     *
     * @template {{ order?: number|null, _id: string }} T
     * @param {T[]} array
     * @returns {T[]}
     */
    sort(array) {
      return sortByOrder(array)
    },
  }
}

export default new SortUtility()
